import { ref, watch } from "vue"
import api from "@/api"
import S3 from "@/utils/s3"
import { EXTENSION_TO_MIME } from "@/utils/files"

export function useInteractionMedia(interactionRef, options = {}) {
  const { enabled = true } = options

  const mediaObjs = ref([])
  const isLoading = ref(false)
  const error = ref(null)

  const fetchMedia = async () => {
    const interaction = interactionRef.value

    if (!enabled || !interaction?.media_list?.length) {
      mediaObjs.value = []
      return
    }

    isLoading.value = true
    error.value = null

    try {
      const results = await Promise.all(
        interaction.media_list.map(async (uri) => {
          const { bucket, key, fileName, fileExtension } = S3.parseS3Uri(uri)

          const { data } = await api.interactions.getMediaDownloadLink({
            interaction_id: interaction.id,
            bucket_name: bucket,
            file_key: key,
            file_name: fileName,
          })

          return {
            url: data,
            media_name: fileName,
            media_type: EXTENSION_TO_MIME[fileExtension] || "",
          }
        })
      )

      mediaObjs.value = results
    } catch (err) {
      console.error("Failed to fetch media links:", err)
      error.value = err
      mediaObjs.value = []
    } finally {
      isLoading.value = false
    }
  }

  watch(interactionRef, fetchMedia, { immediate: true })

  return {
    mediaObjs,
    isLoading,
    error,
  }
}
